import React from "react"
import styled, { css } from "styled-components"
import MenuItems from "./MenuItems"
import { Link } from "gatsby"
import Parser from "html-react-parser"

import Typography from "@material-ui/core/Typography"

import * as theme from "../../theme"

const MobileMenu = props => {
  return (
    <Menu {...props}>
      <MenuItems slug="main-menu">
        {items => {
          return items.map(item => (
            <WrapItem key={item.id}>
              {!item.children ? (
                <Item
                  to={item.pathname}
                  className={item.active || item.activeParent ? "active" : ""}
                >
                  <Title className="item-title" variant="subtitle1">
                    {Parser(item.title)}
                  </Title>
                </Item>
              ) : (
                <Section>
                  {!!item.children &&
                    item.children.map(subItem => {
                      return (
                        <Item key={subItem.id} to={subItem.pathname}>
                          <Title className="item-title" variant="subtitle1">
                            {Parser(subItem.title)}
                          </Title>
                        </Item>
                      )
                    })}
                </Section>
              )}
            </WrapItem>
          ))
        }}
      </MenuItems>
    </Menu>
  )
}

export default MobileMenu

const menuClose = css`
  transform: translateX(120%);
  opacity: 0;
`
const menuOpen = css`
  transform: translateX(0);
  opacity: 1;
`

const Menu = styled.div`
  padding: 10px 20px;
  will-change: transform, opacity;
  ${props => (!!props.menuState ? menuOpen : menuClose)}
  position: fixed;
  top: 114px; /* height of header */
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 100;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
  background: ${theme.color.primary};
  @media (min-width: 800px) {
    display: none;
  }
`

const WrapItem = styled.div``
const Section = styled.div``

const Item = styled(Link)`
  color: white;
  text-decoration: none;
  /* padding: 8px 20px; */
  width: 100%;
`

const Title = styled(Typography)`
  padding: 5px 0;
  color: white;
  text-transform: uppercase;
`
